import { REGISTRIES } from '../../config/languages';
// import { defaultRegistry } from "../../config/LANGUAGES";

export const RegistryMapper = {
  hydrate(registry) {
    if (!Object.keys(REGISTRIES).includes(registry)) {
      return REGISTRIES.unbranded;
    }
    return registry;
  },
};
